import React, { useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid'; // For version 5
import { SpacingBox, FluidPrimaryButton, InfoCaption } from '../../Components';
import {
  getCurrentOrder,
  isProductInCurrentOrder,
  getSeasonForProduct,
} from '../../selectors';
import AppContext from '../../AppContext';
import { productName } from '../../utils/products';
import { isOrderEditable } from '../../utils/order';
import { routes } from '../../routes';
import { getTranslateByScope } from '../../i18n';

const translate = getTranslateByScope('app.productDetail');

export const AddProductToOrderButton = withRouter(
  ({ history, product, tischOffensiveId, deliveryDate }) => {
    const context = useContext(AppContext);
    const currentOrder = getCurrentOrder(context);
    const productAlreadyInOrder = isProductInCurrentOrder(context)(product);

    const isReadonly = !isOrderEditable(_.get(currentOrder, 'doc'));
    const onSuccess = () => {
      context.actions.setToast({
        title: translate('addedMessage.title'),
        text: translate('addedMessage.description', {
          name: productName(product),
        }),
        action: {
          text: translate('toCurrentOrderText'),
          onClick: () => history.push(routes.currentOrder),
        },
      });
    };

    const onAddToOrder = () => {
      if (!currentOrder) return;
      context.actions.onAddOrUpdateOrderProduct({
        onSuccess,
        order: currentOrder.doc,
        product: {
          id: uuidv4(),
          number: product.number,
          tischOffensiveId,
          season: getSeasonForProduct({
            number: product.number,
            orderSeason: currentOrder.doc.season,
            context,
          }),
          createdAt: new Date(),
          deliveryDate,
        },
      });
    };

    return !isReadonly ? (
      <SpacingBox marginTop="lg">
        <FluidPrimaryButton
          onClick={onAddToOrder}
          text={translate('addToOrder')}
        />
        {productAlreadyInOrder && (
          <InfoCaption>{translate('productAlreadyInOrder')}</InfoCaption>
        )}
      </SpacingBox>
    ) : (
      <InfoCaption>{translate('orderClosed')}</InfoCaption>
    );
  },
);

export default AddProductToOrderButton;
